import {
  PublicClientApplication,
  BrowserCacheLocation,
  LogLevel,
  Configuration,
} from '@azure/msal-browser';
import { environment } from '../../environments/environment';

// MSAL Configuration
export const msalConfig: Configuration = {
  auth: {
    clientId: `${environment.clientId}`, // Replace with your Azure App Registration Client ID
    authority: `https://login.microsoftonline.com/${environment.tenantId}`, // Replace with your tenant ID or 'common'
    redirectUri: `${environment.redirectUri}`, // Your app's redirect URI
    postLogoutRedirectUri: `${environment.postRedirectUri}`,
  },
  cache: {
    cacheLocation: BrowserCacheLocation.SessionStorage,
    // Intentionally false for modern browsers; enable only for legacy browsers
    // (for example IE11/older Edge) where auth state can be lost during redirects.
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: LogLevel, message: string) => {
        if (environment.production) {
          return;
        }

        switch (level) {
          case LogLevel.Error:
            console.error(message);
            break;
          case LogLevel.Warning:
            console.warn(message);
            break;
          case LogLevel.Info:
            console.info(message);
            break;
          case LogLevel.Verbose:
            console.debug(message);
            break;
          default:
            break;
        }
      },
      logLevel: environment.production ? LogLevel.Error : LogLevel.Info,
      piiLoggingEnabled: false,
    },
  },
};

// Factory function for MSAL instance
export function MSALInstanceFactory(): PublicClientApplication {
  return new PublicClientApplication(msalConfig);
}
